module.exports = __webpack_public_path__ + "img/new_icein_logo.8288aa95.svg";